export function snackMessageShow(message) {
    return {
        type: 'SNACK_MESSAGE_SHOW',
        payload: {
            message: message,
        }
    }
}

export function snackMessageHide() {
    return {
        type: 'SNACK_MESSAGE_HIDE',
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/snack_message.js